export const SET_LOGIN_STATUS = 'user/setLoginStatus'
export const LOGIN_WECHAT_AUTH = 'user/loginWechatAuth'
export const FED_LOGOUT = 'user/fedLogOut' 
export const GET_USER_INFO = 'user/action_getiInfo'
export const SET_USER_INFO = 'user/action_setInfo'


export const SHOW_BOTTOM_TAB = 'app/showBottomTab'
export const HIDE_BOTTOM_TAB = 'app/hideBottomTab'


export const READING_SWITCH_LEVEL = 'article/switchLevel'
export const SELECT_ARTICLE_CONTENT = 'article/selectArticleContent'
export const GET_ARTICLE_DETAIL = 'article/getArticleDetail'
export const GET_ARTICLE_CONTENT = 'article/getArticleContent'
export const UPDATE_WORD_BOOK = 'article/updateWordBook'
export const GET_ARTICLE_QUIZ = 'article/getArticleQuestions'
export const UPDATE_ARTICLE_ANSWER = 'article/updateArticleAnswer'
export const SET_ARTICLE_RESULT = 'article/setArticleResult'
export const RESET_ARTICLE = 'article/resetArticle'







//////////////////
// WEBPACK FOOTER
// ./app/store/action-types.js
// module id = null
// module chunks = 